export default "__VITE_ASSET__7Ha$PchX__"